<div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Detalle por Artículo</h4>
    </div>

    <div class="modal-body">

        <div class="row cabecera">

            <div class="col-12 col-lg-6">
                <p>Código:</p> &nbsp;{{Item.ItemCode}}
            </div>

            <div class="col-12 col-lg-6">
                <p>Bodega:</p> 
                <select class="form-control" [(ngModel)]="bodegaSelecciona" (ngModelChange)="cambiaBodega()">
                    <option *ngFor="let item of bodegas" value="{{item.WhsCode}}">{{item.WhsName}}</option>
                </select>
            </div>

            <div class="col-12 col-lg-6">
                <p>Descripción:</p>
                &nbsp;{{Item.ItemName}}
            </div>
            
            <div class="col-12 col-lg-6">
                <p>Cantidad Fabricada:</p>
                &nbsp;{{detalles?.Quantity}}
            </div>

        </div>

        <div class="tabla-detalle">

            <ngx-table #table [configuration]="configuration" [data]="dataTabla" [columns]="columns"></ngx-table>

            <ng-template #frmItemCode let-row let-rowIndex="rowIndex">

                <div style="display: flex;">

                    <div class="estrella" style="display: flex;justify-content: center;align-items: center;height: 100%;padding: 10px;" *ngIf="row.EsCompuesto == 'Y'">
                        <i class="fa-solid fa-star" style="color: #ffdc00;cursor: pointer;" (click)="abrirListaItem(row)"></i>
                    </div>

                    <div>{{row.Code}}</div>

                </div>

            </ng-template>

            <ng-template #frmDisponibleVenta let-row let-rowIndex="rowIndex">

                {{row.StockDisponible}}
    
            </ng-template>

            <ng-template #frmPrice let-row let-rowIndex="rowIndex">
              <div *ngIf="row.Currency != 'CLP'">{{row.Price | iNDCLP}}</div>
              <div *ngIf="row.Currency == 'CLP'">{{row.Price | iNDCLP}}</div>
            </ng-template>

        </div>

        <div class="row">
            <div class="col-12" style="display: flex;justify-content: right;">
                    <p style="font-weight: bold;padding-right: 5px;">Stock Simulado</p>
                    {{detalles?.OnHandVirtual}}
            </div>
        </div>

    </div>
    
    <div class="modal-footer">
        <button (click)="cerrar()" type="button" class="btn btn-success">Cerrar</button>
    </div>

</div>